<template>
  <div class="home">
    <div v-if="isShow == true || id == ''" class="imgbox">
      <div class="img2">
        <img src="../assets/bull.png" alt="" />
      </div>
    </div>
    <div v-else class="Views_div">
      <vue-office-pdf v-if="link_url.endsWith('.pdf')" :src="link_url" height="100%" @rendered="renderedHandler"
        @error="errorHandler" />
      <vue-office-docx v-else-if="link_url.endsWith('.docx')" :src="link_url" style="height: 100vh; width: 100%"
        @rendered="rendered" />
      <!-- <div v-else-if="isDocx(link_url)" height='100%'>{{ link_url }}</div> -->
      <iframe v-else :src="link_url" frameborder="0" height="100%" width="100%" allow="fullscreen" webkitallowfullscreen
        mozallowfullscreen></iframe>
      <!-- <iframe src="https://view.officeapps.live.com/op/view.aspx?src=https://vross.zhyell.com/qrcode/yidazhiershida.pdf"  frameborder="0"></iframe> -->
    </div>
  </div>
</template>
<script>
import { removeToken } from "@/utils/storage";
// 引入VueOfficePdf组件
import VueOfficePdf from "@vue-office/pdf";
// 引入VueOfficeDocx组件
import VueOfficeDocx from "@vue-office/docx";
// 引入相关样式
import "@vue-office/docx/lib/index.css";
export default {
  name: "HomeView",
  components: {
    VueOfficePdf,
    VueOfficeDocx
  },
  data() {
    return {
      id: "",
      link_url: "",
      numPages: null,
      isShow: false,
      currentRecordsId: ""
      // pdfSrc: loadingTask
    };
  },

  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getQrcode();
    }
    window.addEventListener("beforeunload", this.handlePageClose);
  },

  async beforeDestroy() {
    window.removeEventListener("beforeunload", this.handlePageClose);
  },

  destroyed() {
    localStorage.removeItem("currentRecordsId");
    removeToken();
  },

  methods: {
    async handlePageClose() {
      // 以下是关闭页面的处理逻辑
      // console.log("页面关闭");
      const id = localStorage.getItem("currentRecordsId");
      if (!id) {
        return;
      }
      // const leave_time = new Date();
      const leave_time = this.formatDate(new Date());
      // console.log(id);
      // console.log(leave_time);
      localStorage.removeItem("currentRecordsId");
      const params = {
        id,
        leave_time
      };
      let res;
      try {
        res = await this.$httpApi.updateRecords(params);
      } catch (error) {
        console.log(error);
      }
      // console.log("更新记录");
      // console.log(res);
    },

    renderedHandler() {
      console.log("渲染完成");
    },

    errorHandler() {
      console.log("渲染失败");
    },

    rendered() { },

    getQrcode() {
      const _this = this;
      this.$axios
        .post("https://develop.himeit.com/api/admin/get_qrcode_info", {
          id: _this.id
        })
        .then(function (res) {
          console.log(res.data.data);
          // eslint-disable-next-line eqeqeq
          if (res.data.code == 0 && res.data.data.status == 0) {
            console.log(res.data.data.is_login);
            // 是否需要登录才能访问 - 1否 2是
            if (res?.data?.data?.is_login === 2) {
              const token = _this.$token.get();
              // console.log("token", token);
              if (!token) {
                _this.$message({
                  type: "warning",
                  message: "请先登录",
                  center: true
                });
                // 携带当前路由跳转到登录
                _this.$router.push(
                  `/login?redirect=${_this.$route.fullPath}&urlId=${res.data.data.id}`
                );
                return;
              }
              _this.link_url = res.data.data.url;
              // 防止页面刷新重复记录
              if (!localStorage.getItem("currentRecordsId")) {
                _this.loginRecords();
              }
              if (res.data.data.is_dump || res.data.data.url.endsWith(".jpg")) {
                window.location.href = res.data.data.url;
              }
            } else {
              // 不需要登录
              _this.link_url = res.data.data.url;
              _this.logNumCode();
              if (res.data.data.is_dump || res.data.data.url.endsWith(".jpg")) {
                window.location.href = res.data.data.url;
              }
            }
            // eslint-disable-next-line eqeqeq
          } else {
            _this.isShow = true;
          }
        })
        .catch(function (err) {
          console.log(err, "err");
          // alert('没有识别到当前url')
        });
    },

    // 登录记录
    async loginRecords() {
      const params = {
        url_id: this.id
      };
      let res;
      try {
        res = await this.$httpApi.loginRecords(params);
      } catch (error) {
        console.log(error);
      }
      // console.log("已登录qrcode_records");
      this.currentRecordsId = res?.data?.data?.id;
      // console.log("当前这条记录id");
      // console.log(this.currentRecordsId);
      localStorage.setItem("currentRecordsId", this.currentRecordsId);
    },

    // 未登录记录
    async logNumCode() {
      const params = {
        url_id: this.id
      };
      let res;
      try {
        res = await this.$httpApi.logoutRecords(params);
      } catch (error) {
        console.log(error);
      }
      console.log("未登录qrcode_record");
    },

    // 格式化时间
    formatDate(isoString) {
      const date = new Date(isoString);
      const padZero = num => num.toString().padStart(2, "0");

      const year = date.getFullYear();
      const month = padZero(date.getMonth() + 1);
      const day = padZero(date.getDate());
      const hours = padZero(date.getHours());
      const minutes = padZero(date.getMinutes());
      const seconds = padZero(date.getSeconds());

      return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    },

    isRealPageClose() {
      // 方法1：检查鼠标位置（关闭时通常在关闭按钮附近）
      if (window.event && window.event.clientY < 0) {
        return true;
      }

      // 方法2：检查performance API
      try {
        const navEntries = performance.getEntriesByType("navigation");
        if (navEntries.length > 0) {
          return navEntries[0].type !== "reload";
        }
      } catch (e) {
        console.log(e);
      }

      // 方法3：检查document.wasDiscarded
      if ("document" in window && document.wasDiscarded) {
        return true;
      }

      // 方法4：Safari专用检测
      if (this.isSafari()) {
        return this.checkSafariPageClose();
      }

      // 默认认为是关闭
      return true;
    },

    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },

    checkSafariPageClose() {
      // Safari专用检测逻辑
      let isClose = true;

      // 检查是否是从其他标签页切换回来
      document.addEventListener(
        "visibilitychange",
        () => {
          if (document.visibilityState === "visible") {
            isClose = false;
          }
        },
        { once: true }
      );

      return isClose;
    }
  }
};
// }
</script>
<style>
body {
  overflow-y: none;
}

.imgbox {
  width: 100%;
  height: 100vh;
  position: relative;
  /* background-color: rgba(0, 0, 0, .3); */
}

.img2 {
  margin-top: 20px;
  width: 100%;
  height: 100%;
}

.img2 img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.Views_div {
  height: 100vh;
  overflow-y: none !important;
}

.Views_div .vue-office-pdf {
  height: 100% !important;
}

.Views_div iframe {
  height: 100%;
  width: 100%;
  overflow-y: none;
}

.Views_div iframe img {
  height: 100%;
  width: 100%;
  object-fit: fill;
}

.pdf-container {
  width: 100%;
  height: 800px;
}
</style>
